import React from 'react';
import { Redirect } from 'react-router-dom';
//
import SupportRequestList from './SupportRequestList';
import ConformityReportList from './ConformityReportList';
import ConformityReport from './ConformityReport';
import {
  SupportRequestCollab,
  ConformityCollab
} from 'pages/Collaborations'
//
import {
  ROUTE_DASHBOARD,
  ROUTE_DASH_TASKS,
  ROUTE_CONFORMITY_LIST,
  ROUTE_SUPPORT_REQ_LIST
} from 'fixtures/routes'

// list of Tasks child routes
const routes = [
  {
    path: '/',
    exact: true,
    main: () => <Redirect to={`/${ROUTE_DASHBOARD}/${ROUTE_DASH_TASKS}/${ROUTE_SUPPORT_REQ_LIST}`} />,
    isProtected: true
  },
  {
    path: `/${ROUTE_SUPPORT_REQ_LIST}`,
    exact: true,
    main: () => <SupportRequestList />,
    isProtected: true
  },
  {
    path: `/${ROUTE_CONFORMITY_LIST}`,
    exact: true,
    main: () => <ConformityReportList />,
    isProtected: true
  },
  {
    path: `/${ROUTE_SUPPORT_REQ_LIST}/:taskId`,
    exact: true,
    main: () => <SupportRequestCollab />,
    isProtected: true
  },
  {
    path: `/${ROUTE_CONFORMITY_LIST}/:taskId`,
    exact: true,
    main: () => <ConformityCollab />,
    isProtected: true
  },
  {
    path: `/${ROUTE_CONFORMITY_LIST}/:taskId/report`,
    exact: true,
    main: () => <ConformityReport />,
    isProtected: true
  }
]

export default routes;
